module.exports = __webpack_public_path__ + "img/edit.6b0a0d4d.svg";